import React from "react";
import loader from "Assets/preloader.gif";
import { Flex } from "@chakra-ui/react";

export const Preloader = () => {
  return (
    <Flex
      w={"100%"}
      h={"100vh"}
      justifyContent={"center"}
      alignItems={"center"}
      background={"hsla(0, 0%, 90%,0.61)"}
    >
      <img src={loader} alt="loader" />
    </Flex>
  );
};
